import { UserMap } from "../../../userMap/userMap";

export const TrustUserMapContainer = () => {
    return (
        <UserMap isTrust={true} />
    )
};